import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

type EmptyCustomValuesMessageProps = {
  className?: string;
  center?: boolean;
};

export const EmptyCustomValuesMessage = ({ className, center }: EmptyCustomValuesMessageProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.matchAttributes" });

  return (
    <Inline alignItems="center" justifyContent={center ? "center" : "start"} className={className}>
      <Icon name="missing" color="paletteBlue2" />
      <Typography variant="labelRegular">{t("noCustomValuesAdded")}</Typography>
    </Inline>
  );
};
